import React, { useState, useEffect } from 'react';
import './NameInputModal.css';

function NameInputModal({ isOpen, title, placeholder, defaultValue, onConfirm, onCancel }) {
    const [name, setName] = useState(defaultValue || '');

    useEffect(() => {
        setName(defaultValue || '');
    }, [defaultValue, isOpen]);

    useEffect(() => {
        if (isOpen) {
            // Auto-focus sur l'input quand la modale s'ouvre
            setTimeout(() => {
                const input = document.querySelector('.name-input-modal input');
                if (input) input.focus();
            }, 100);
        }
    }, [isOpen]);

    const handleSubmit = (e) => {
        e.preventDefault();
        if (name.trim()) {
            onConfirm(name.trim());
        }
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Escape') {
            onCancel();
        }
    };

    if (!isOpen) return null;

    return (
        <div className="modal-overlay" onClick={onCancel}>
            <div className="name-input-modal" onClick={(e) => e.stopPropagation()}>
                <div className="modal-header">
                    <h3>{title || 'Nom de la signature'}</h3>
                    <button className="close-btn" onClick={onCancel}>
                        <svg width="20" height="20" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
                        </svg>
                    </button>
                </div>

                <form onSubmit={handleSubmit}>
                    <div className="modal-body">
                        <input
                            type="text"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            onKeyDown={handleKeyDown}
                            placeholder={placeholder || 'Entrez un nom...'}
                            autoComplete="off"
                        />
                    </div>

                    <div className="modal-footer">
                        <button type="button" className="btn-cancel" onClick={onCancel}>
                            Annuler
                        </button>
                        <button type="submit" className="btn-confirm" disabled={!name.trim()}>
                            Confirmer
                        </button>
                    </div>
                </form>
            </div>
        </div>
    );
}

export default NameInputModal;
